import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    '& .react-datepicker-wrapper': {
      width: '100%'
    }
  },
  button: {
    width: '1em',
    height: '1em'
  }
}));
